(() => {
  // Localized concise copy. Readiness blockers only appear when purchase is blocked.
  const reviewCopy = {
    de: ['Noch nicht bestellbar', '', 'Ausschliessliche Kartenzahlung noch nicht bestätigt.', 'Gemeinsame Verlängerungen noch nicht bestätigt.', 'Anbieter-Verwaltung noch nicht bestätigt.', 'CHF-Preise noch nicht bestätigt.'],
    fr: ['Pas encore disponible à l’achat', '', 'Paiement par carte uniquement non confirmé.', 'Renouvellements communs non confirmés.', 'Gestion par le prestataire non confirmée.', 'Prix CHF non confirmés.'],
    en: ['Not yet available to buy', '', 'Card-only payment not yet verified.', 'Grouped renewals not yet verified.', 'Provider management not yet verified.', 'CHF pricing not yet verified.'],
    ar: ['غير متاح للشراء بعد', '', 'لم يتم التحقق من الدفع بالبطاقة حصراً.', 'لم يتم التحقق من التجديدات المشتركة.', 'لم يتم التحقق من إدارة مزود الخدمة.', 'لم يتم التحقق من الأسعار بالفرنك السويسري.']
  };
  const L = {
    de: { title: 'Dein Seifenabo', eyebrow: 'SEIFENABO', close: 'Schliessen', steps: ['Menge', 'Intervall', 'Übersicht'], qtyHint: 'Wie viele Stück dieser Seife pro Lieferung?', custom: 'Eigene Menge', pieces: 'Stück', intervalHint: 'Wie oft sollen wir liefern?', weeks: 'Wochen', every: 'Alle', summaryHint: 'Prüfe deine Lieferung.', add: 'Weitere Seifen hinzufügen', pickTitle: 'Weitere Seifen', pickHint: 'Bis zu zwei weitere Seifen, gleiches Intervall.', pick: 'Hinzufügen', picked: 'Ausgewählt', limit: 'Maximal drei Seifen pro Abo.', empty: 'Aktuell passen keine weiteren Seifen zu diesem Intervall.', noImage: 'Kein Bild', done: 'Zur Übersicht', back: 'Zurück', next: 'Weiter', remove: 'Entfernen', dec: 'Menge verringern', inc: 'Menge erhöhen', variant: 'Variante', perDelivery: 'Pro Lieferung', terms: n => `Wiederkehrende Bestellung alle ${n} Wochen zum angezeigten Preis, bis du kündigst.`, shipping: 'Versand wird im Shopify-Checkout berechnet.', invalid: 'Bitte eine verfügbare Variante und eine ganze Menge ab 1 wählen.', original: 'Deine Seife', from: 'ab', loadingGrid: 'Seifen werden geladen…' },
    fr: { title: 'Votre abonnement savon', eyebrow: 'ABONNEMENT', close: 'Fermer', steps: ['Quantité', 'Fréquence', 'Récapitulatif'], qtyHint: 'Combien de savons par livraison ?', custom: 'Autre quantité', pieces: 'pièces', intervalHint: 'À quelle fréquence livrer ?', weeks: 'semaines', every: 'Toutes les', summaryHint: 'Vérifiez votre livraison.', add: 'Ajouter d’autres savons', pickTitle: 'Autres savons', pickHint: 'Jusqu’à deux autres savons, même fréquence.', pick: 'Ajouter', picked: 'Sélectionné', limit: 'Trois savons maximum par abonnement.', empty: 'Aucun autre savon compatible avec cette fréquence pour le moment.', noImage: 'Pas d’image', done: 'Vers le récapitulatif', back: 'Retour', next: 'Continuer', remove: 'Retirer', dec: 'Réduire la quantité', inc: 'Augmenter la quantité', variant: 'Variante', perDelivery: 'Par livraison', terms: n => `Commande récurrente toutes les ${n} semaines au prix affiché, jusqu’à résiliation.`, shipping: 'Livraison calculée dans le paiement Shopify.', invalid: 'Choisissez une variante disponible et une quantité entière de 1 minimum.', original: 'Votre savon', from: 'dès', loadingGrid: 'Chargement des savons…' },
    en: { title: 'Your soap subscription', eyebrow: 'SUBSCRIPTION', close: 'Close', steps: ['Quantity', 'Interval', 'Summary'], qtyHint: 'How many of this soap per delivery?', custom: 'Custom quantity', pieces: 'pcs', intervalHint: 'How often should we deliver?', weeks: 'weeks', every: 'Every', summaryHint: 'Review your delivery.', add: 'Add more soaps', pickTitle: 'More soaps', pickHint: 'Up to two more soaps, same interval.', pick: 'Add', picked: 'Selected', limit: 'Maximum three soaps per subscription.', empty: 'No other soaps currently match this interval.', noImage: 'No image', done: 'Back to summary', back: 'Back', next: 'Continue', remove: 'Remove', dec: 'Decrease quantity', inc: 'Increase quantity', variant: 'Variant', perDelivery: 'Per delivery', terms: n => `Recurring order every ${n} weeks at the price shown until you cancel.`, shipping: 'Shipping is calculated in Shopify checkout.', invalid: 'Choose an available variant and a whole quantity of at least 1.', original: 'Your soap', from: 'from', loadingGrid: 'Loading soaps…' },
    ar: { title: 'اشتراك الصابون', eyebrow: 'اشتراك', close: 'إغلاق', steps: ['الكمية', 'الفترة', 'الملخص'], qtyHint: 'كم قطعة من هذا الصابون في كل توصيل؟', custom: 'كمية أخرى', pieces: 'قطع', intervalHint: 'كم مرة نوصل؟', weeks: 'أسابيع', every: 'كل', summaryHint: 'راجع توصيلك.', add: 'إضافة صابون آخر', pickTitle: 'صابون إضافي', pickHint: 'حتى نوعين إضافيين، بنفس الفترة.', pick: 'إضافة', picked: 'تم الاختيار', limit: 'ثلاثة أنواع كحد أقصى لكل اشتراك.', empty: 'لا يوجد صابون آخر متوافق مع هذه الفترة حالياً.', noImage: 'لا توجد صورة', done: 'العودة إلى الملخص', back: 'رجوع', next: 'متابعة', remove: 'إزالة', dec: 'تقليل الكمية', inc: 'زيادة الكمية', variant: 'النوع', perDelivery: 'لكل توصيل', terms: n => `طلب متكرر كل ${n} أسابيع بالسعر المعروض حتى تلغي.`, shipping: 'يُحسب الشحن في دفع Shopify.', invalid: 'اختر نوعاً متاحاً وكمية صحيحة لا تقل عن 1.', original: 'صابونك', from: 'من', loadingGrid: 'جارٍ تحميل الصابون…' }
  };
  const checkoutCopy = {
    de: ['Shopify prüft die Abo-Auswahl…', 'Die Abo-Daten konnten nicht geprüft werden. Einmalkauf bleibt verfügbar.', 'Sicher zum Shopify-Checkout', 'Preis oder Verfügbarkeit geändert. Bitte die Auswahl prüfen und erneut bestätigen.', 'Unklarer Warenkorbstatus. Bitte den Warenkorb prüfen; es wird nicht automatisch erneut hinzugefügt.', 'Warenkorb prüfen', 'Auswahl wird geprüft…', 'Diese Auswahl hat keinen gemeinsamen, bestätigten Wochenplan.', ''],
    fr: ['Shopify vérifie la sélection…', 'Les données d’abonnement sont indisponibles. L’achat unique reste possible.', 'Continuer vers le paiement Shopify', 'Le prix ou la disponibilité a changé. Vérifiez et confirmez à nouveau.', 'État du panier incertain. Vérifiez le panier ; aucun ajout automatique ne sera répété.', 'Vérifier le panier', 'Vérification de la sélection…', 'Cette sélection n’a pas de formule hebdomadaire commune confirmée.', ''],
    en: ['Shopify is checking subscription options…', 'Subscription data could not be verified. One-time purchase remains available.', 'Continue securely to Shopify checkout', 'Price or availability changed. Review and confirm your selection again.', 'Uncertain cart status. Check your cart; nothing will be automatically added again.', 'Review cart', 'Verifying selection…', 'This selection has no shared, verified weekly plan.', ''],
    ar: ['تتحقق Shopify من خيارات الاشتراك…', 'تعذر التحقق من بيانات الاشتراك. لا يزال الشراء لمرة واحدة متاحاً.', 'المتابعة بأمان إلى دفع Shopify', 'تغير السعر أو التوفر. راجع الاختيار وأكده مجدداً.', 'حالة السلة غير مؤكدة. راجع السلة؛ لن تتم إضافة المنتجات تلقائياً مرة أخرى.', 'مراجعة السلة', 'جارٍ التحقق من الاختيار…', 'لا توجد خطة أسبوعية مشتركة مؤكدة لهذا الاختيار.', '']
  };
  const INTERVALS = [4, 6, 8, 12];
  document.querySelectorAll('[data-product-detail]').forEach(root => {
    const open = root.querySelector('[data-product-abo-open]');
    const node = root.querySelector('[data-product-abo-catalog]');
    if (!open || !node) return;
    let catalog;
    try { catalog = JSON.parse(node.textContent); } catch { open.disabled = true; return; }
    const lang = (document.documentElement.lang || 'de').split('-')[0];
    const t = { ...(L[lang] || L.de), pickHint: ({
      de: 'Wähle weitere Seifen für dasselbe Lieferintervall.',
      en: 'Choose more soaps for the same delivery interval.',
      fr: 'Choisissez d’autres savons avec la même fréquence de livraison.',
      ar: 'اختر المزيد من الصابون بنفس وتيرة التوصيل.'
    })[lang] || 'Wähle weitere Seifen für dasselbe Lieferintervall.' };
    const c = checkoutCopy[lang] || checkoutCopy.de;
    const r = reviewCopy[lang] || reviewCopy.de;
    const rtl = document.documentElement.dir === 'rtl' || lang === 'ar';
    const pendingKey = 'seifenlaedeli:product-abo:pending:v1';
    const cartRoot = window.Shopify?.routes?.root || '/';
    let offer = null;
    const discoverEntry = open.hasAttribute('data-product-abo-discover');
    const currentProductId = String(catalog[0].id);
    // Liquid uses actual allocated, approved individual plans. This immutable
    // hint can open the wizard immediately, but is never purchase authority.
    const initialEligibleVariants = new Set(catalog[0].variants
      .filter(variant => variant.subscriptionEligible === true && variant.available)
      .map(variant => String(variant.id)));
    const entryDescription = root.querySelector('[data-product-abo-description]');
    let discoverySettled = false;
    const syncEntry = () => {
      if (!discoverEntry) return;
      const selectedId = root.querySelector('[data-variant-id]')?.value;
      const eligible = !discoverySettled ? initialEligibleVariants.has(selectedId)
        : offer?.variants.some(variant => variant.productId === currentProductId
        && variant.id === selectedId && variant.available && variant.plans.some(plan =>
          /^\d+$/.test(plan.id) && /^gid:\/\/shopify\/SellingPlanGroup\/\d+$/.test(plan.groupId)
          && [4, 6, 8, 12].includes(plan.intervalWeeks)));
      open.hidden = !eligible;
      open.style.display = eligible ? '' : 'none';
      if (entryDescription) entryDescription.hidden = !eligible;
    };
    let loading = false;
    let providerError = false;
    let submitting = false;
    let uncertain = false;
    let fingerprint = '';
    let requestId = crypto.randomUUID();
    const endpoint = new URL(open.dataset.offerEndpoint, location.origin);
    const request = async (url, options = {}) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {
          ...options, signal: controller.signal, cache: 'no-store',
          headers: { Accept: 'application/json', ...options.headers },
        });
        if (!response.ok) throw new Error(`HTTP_${response.status}`);
        return await response.json();
      } finally { clearTimeout(timeout); }
    };
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'CHF'
    }).format(cents / 100);
    const el = (tag, text, attrs = {}) => {
      const element = document.createElement(tag);
      if (text) element.textContent = text;
      Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value));
      return element;
    };
    const button = (text, action, attrs = {}) => {
      const result = el('button', text, { type: 'button', ...attrs });
      result.addEventListener('click', action);
      return result;
    };

    // ---- Display-only imagery. Never consulted for eligibility, price or stock. ----
    const images = new Map(); // productId -> { status: 'loading'|'ok'|'missing', src, alt }
    if (catalog[0].image) images.set(currentProductId, { status: 'ok', src: catalog[0].image, alt: catalog[0].imageAlt || catalog[0].title });
    else images.set(currentProductId, { status: 'missing' });
    const safeImage = raw => {
      if (typeof raw !== 'string' || !raw) return null;
      try {
        const url = new URL(raw, location.href);
        if (url.protocol !== 'https:' && url.origin !== location.origin) return null;
        if (url.origin !== location.origin && !/(^|\.)shopify(cdn)?\.com$/.test(url.hostname)) return null;
        url.searchParams.set('width', '480');
        return url.href;
      } catch { return null; }
    };
    const loadImage = product => {
      const id = String(product.id);
      if (images.has(id)) return;
      if (typeof product.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/i.test(product.handle)) { images.set(id, { status: 'missing' }); return; }
      images.set(id, { status: 'loading' });
      request(`${cartRoot}products/${encodeURIComponent(product.handle)}.js`).then(data => {
        // Identity check: the handle must resolve to the same Shopify product.
        if (String(data?.id) !== id) throw new Error('IDENTITY');
        const src = safeImage(data.featured_image || data.images?.[0]);
        const alt = data.media?.[0]?.alt || product.title;
        images.set(id, src ? { status: 'ok', src, alt } : { status: 'missing' });
      }).catch(() => images.set(id, { status: 'missing' }))
        .finally(() => { if (dialog.open && (step === 2 || step === 3)) render(); });
    };
    const thumb = (product, cls) => {
      const box = el('div', '', { class: cls });
      const info = images.get(String(product.id));
      if (info?.status === 'ok') {
        const img = el('img', '', { src: info.src, alt: info.alt || product.title, loading: 'lazy', decoding: 'async' });
        img.addEventListener('error', () => { images.set(String(product.id), { status: 'missing' }); box.replaceChildren(el('span', t.noImage)); box.classList.add('is-missing'); }, { once: true });
        box.append(img);
      } else if (info?.status === 'loading') box.classList.add('is-loading');
      else { box.classList.add('is-missing'); box.append(el('span', t.noImage)); }
      return box;
    };

    // ---- Dialog shell ----
    const dialog = el('dialog', '', { class: 'product-abo-dialog', 'aria-labelledby': `abo-title-${currentProductId}`, dir: rtl ? 'rtl' : 'ltr' });
    const shell = el('div', '', { class: 'pa-shell' });
    const closeButton = button('', () => dialog.close(), { class: 'pa-close', 'aria-label': t.close, 'data-focus-key': 'close' });
    closeButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    const progress = el('ol', '', { class: 'pa-steps' });
    const body = el('div', '', { class: 'pa-body' });
    const error = el('p', '', { class: 'pa-error', role: 'alert', 'aria-live': 'polite' });
    const footer = el('footer', '', { class: 'pa-footer' });
    shell.append(closeButton, progress, body, error, footer);
    dialog.append(shell);
    root.append(dialog);

    let step = 0; // 0 quantity, 1 interval, 2 summary, 3 image selection (sub-step of summary)
    let weeks = 4;
    let lastPdpVariant = '';
    let lines = [{ product: catalog[0], variant: '', quantity: 2 }];
    const variantFor = line => line.product.variants.find(v => String(v.id) === line.variant);
    const planFor = () => {
      const first = variantFor(lines[0]);
      // Plan compatibility enables review, not permission to purchase.
      // Payment/renewal evidence is still enforced by offer.ready and the server.
      return first?.plans?.find(plan => plan.intervalWeeks === weeks
        && lines.every(line => variantFor(line)?.plans?.some(p => p.id === plan.id && p.groupId === plan.groupId && p.intervalWeeks === weeks)));
    };
    const planKeys = variant => new Set((variant?.plans || []).filter(p => p.intervalWeeks === weeks).map(p => `${p.id}|${p.groupId}`));
    // Plans shared by every selected line except `skip` (null = none skipped).
    const sharedKeys = skip => {
      let shared = null;
      lines.forEach((line, i) => {
        if (i === skip) return;
        const keys = planKeys(variantFor(line));
        shared = shared ? new Set([...shared].filter(k => keys.has(k))) : keys;
      });
      return shared;
    };
    const variantCompatible = (variant, skip) => {
      if (!variant?.available) return false;
      if (!offer) return skip === 0 && lines.length === 1; // before authority loads, only primary availability
      const own = planKeys(variant);
      if (!own.size) return false;
      const shared = sharedKeys(skip);
      return shared === null || [...own].some(k => shared.has(k));
    };
    const compatibleVariants = (product, skip) => product.variants.filter(v => variantCompatible(v, skip));
    const intervalShared = n => {
      if (!offer) return true;
      const saved = weeks; weeks = n;
      const ok = Boolean(planFor());
      weeks = saved;
      return ok;
    };
    const valid = () => lines.length > 0
      && new Set(lines.map(line => String(line.product.id))).size === lines.length
      && lines.every(line => variantFor(line)?.available && Number.isSafeInteger(line.quantity) && line.quantity >= 1);

    const stepper = line => {
      const id = line.product.id;
      const wrap = el('div', '', { class: 'pa-stepper', role: 'group', 'aria-label': `${line.product.title}: ${t.custom}` });
      const input = el('input', '', { type: 'number', min: '1', step: '1', inputmode: 'numeric', value: String(line.quantity), 'aria-label': `${t.custom} ${line.product.title}`, 'data-focus-key': `quantity-${id}` });
      input.addEventListener('input', () => { line.quantity = Number(input.value); });
      input.addEventListener('change', () => render());
      const dec = button('−', () => { line.quantity = Math.max(1, (Number.isSafeInteger(line.quantity) ? line.quantity : 1) - 1); render(); }, { 'aria-label': t.dec, 'data-focus-key': `qty-dec-${id}` });
      dec.disabled = line.quantity <= 1;
      const inc = button('+', () => { line.quantity = (Number.isSafeInteger(line.quantity) && line.quantity >= 1 ? line.quantity : 0) + 1; render(); }, { 'aria-label': t.inc, 'data-focus-key': `qty-inc-${id}` });
      wrap.append(dec, input, inc);
      return wrap;
    };
    const variantField = (line, index) => {
      const label = el('label', '', { class: 'pa-field' });
      label.append(el('span', t.variant));
      const select = el('select', '', { 'data-focus-key': `variant-${line.product.id}` });
      line.product.variants.forEach(variant => {
        const option = el('option', `${variant.title} — ${money(variant.price)}`, { value: String(variant.id) });
        option.disabled = !(String(variant.id) === line.variant ? variant.available : (index === 0 && !offer ? variant.available : variantCompatible(variant, index)));
        option.selected = String(variant.id) === line.variant;
        select.append(option);
      });
      select.value = line.variant;
      select.addEventListener('change', () => { line.variant = select.value; render(); });
      label.append(select);
      return label;
    };
    const lineTotal = line => {
      const v = variantFor(line);
      return v && Number.isSafeInteger(line.quantity) && line.quantity >= 1 ? money(v.price * line.quantity) : '—';
    };

    const renderProgress = () => {
      progress.replaceChildren();
      const current = step === 3 ? 2 : step;
      t.steps.forEach((name, i) => {
        const li = el('li', '', { class: i === current ? 'is-current' : i < current ? 'is-done' : '' });
        if (i === current) li.setAttribute('aria-current', 'step');
        li.append(el('i', String(i + 1), { 'aria-hidden': 'true' }), el('span', name));
        progress.append(li);
      });
    };
    const head = (title, hint) => {
      const wrap = el('div', '', { class: 'pa-head' });
      const h = el('h3', title, { tabindex: '-1', id: `abo-title-${currentProductId}` });
      wrap.append(el('p', t.eyebrow, { class: 'pa-eyebrow' }), h);
      if (hint) wrap.append(el('p', hint, { class: 'pa-hint' }));
      body.append(wrap);
      return h;
    };

    const renderQuantity = () => {
      const line = lines[0];
      const choices = el('div', '', { class: 'pa-choices pa-choices--qty', role: 'group', 'aria-label': t.steps[0] });
      [2, 3, 5].forEach(n => {
        const b = button('', () => { line.quantity = n; render(); }, { class: `pa-choice${line.quantity === n ? ' is-selected' : ''}`, 'aria-pressed': String(line.quantity === n), 'data-focus-key': `preset-${n}` });
        b.append(el('strong', String(n)), el('small', t.pieces));
        choices.append(b);
      });
      const custom = el('div', '', { class: `pa-custom${[2, 3, 5].includes(line.quantity) ? '' : ' is-selected'}` });
      custom.append(el('span', t.custom), stepper(line));
      body.append(choices, custom);
      if (line.product.variants.length > 1) body.append(variantField(line, 0));
    };
    const renderInterval = () => {
      const choices = el('div', '', { class: 'pa-choices pa-choices--interval', role: 'group', 'aria-label': t.steps[1] });
      INTERVALS.forEach(n => {
        const ok = intervalShared(n);
        const b = button('', () => { weeks = n; render(); }, { class: `pa-choice${weeks === n ? ' is-selected' : ''}`, 'aria-pressed': String(weeks === n), 'data-focus-key': `interval-${n}` });
        b.disabled = !ok && weeks !== n;
        b.append(el('small', t.every), el('strong', `${n} ${t.weeks}`));
        choices.append(b);
      });
      body.append(choices);
    };
    const renderSummary = () => {
      const meta = el('div', '', { class: 'pa-meta' });
      meta.append(el('span', `${t.every} ${weeks} ${t.weeks}`), button(t.steps[1], () => { step = 1; render(true); }, { class: 'pa-link', 'data-focus-key': 'edit-interval' }));
      body.append(meta);
      const list = el('ul', '', { class: 'pa-lines' });
      lines.forEach((line, index) => {
        const v = variantFor(line);
        const li = el('li', '', { class: 'pa-line', 'data-line': String(line.product.id) });
        li.append(thumb(line.product, 'pa-thumb'));
        const info = el('div', '', { class: 'pa-line__info' });
        info.append(el('strong', line.product.title));
        const sub = [index === 0 ? t.original : null, v && line.product.variants.length > 1 ? v.title : null, v ? money(v.price) : null].filter(Boolean).join(' · ');
        info.append(el('small', sub));
        if (index && line.product.variants.length > 1) info.append(variantField(line, index));
        const controls = el('div', '', { class: 'pa-line__controls' });
        controls.append(stepper(line));
        if (index) controls.append(button(t.remove, () => { lines.splice(index, 1); render(); }, { class: 'pa-link pa-link--danger', 'data-focus-key': `remove-${line.product.id}` }));
        info.append(controls);
        li.append(info, el('span', lineTotal(line), { class: 'pa-line__total' }));
        list.append(li);
      });
      body.append(list);
      const add = button('', () => { step = 3; render(true); }, { class: 'pa-add', 'data-focus-key': 'add-soaps' });
      add.append(el('span', '+', { 'aria-hidden': 'true' }), el('span', t.add));
      add.disabled = submitting;
      body.append(add);
      const total = el('div', '', { class: 'pa-total' });
      total.append(el('span', t.perDelivery), el('strong', valid() ? money(lines.reduce((sum, line) => sum + variantFor(line).price * line.quantity, 0)) : '—'));
      body.append(total);
      const ready = offer?.ready && !providerError && !loading && valid() && planFor()
        && (window.Shopify?.currency?.active || 'CHF') === offer.currency;
      if (offer && !planFor()) body.append(el('p', c[7], { class: 'pa-notice', role: 'status' }));
      else if (offer && !ready && !loading && offer.blockers?.length) {
        const box = el('div', '', { class: 'pa-notice', role: 'status' });
        box.append(el('strong', r[0]));
        const messages = { CARD_ONLY_NOT_VERIFIED: r[2], GROUPED_RENEWALS_NOT_VERIFIED: r[3], PROVIDER_LIFECYCLE_OR_PORTAL_NOT_VERIFIED: r[4], CHF_PRICING_NOT_VERIFIED: r[5] };
        offer.blockers.forEach(blocker => { if (messages[blocker]) box.append(el('span', messages[blocker])); });
        body.append(box);
      }
      body.append(el('p', `${t.terms(weeks)} ${t.shipping}`, { class: 'pa-terms' }));
      const checkout = button(submitting ? c[6] : c[2], checkoutSelection, { class: 'pa-primary pa-checkout', 'data-focus-key': 'checkout' });
      checkout.disabled = !ready || submitting || uncertain;
      body.append(checkout);
      if (uncertain) {
        body.append(el('p', c[4], { class: 'pa-notice pa-notice--error', role: 'alert' }), el('a', c[5], { href: `${cartRoot}cart`, class: 'pa-secondary', 'data-focus-key': 'cart-check' }));
      }
    };
    const renderPicker = () => {
      const candidates = catalog.filter(p => String(p.id) !== currentProductId);
      if (loading && !offer) { body.append(el('p', t.loadingGrid, { class: 'pa-hint', role: 'status' })); return; }
      const extras = lines.length - 1;
      const status = el('p', `${extras} · ${t.pickHint}`, { class: 'pa-count', role: 'status', 'aria-live': 'polite' });
      body.append(status);
      const items = candidates.map(product => {
        const index = lines.findIndex(line => String(line.product.id) === String(product.id));
        return { product, index, compatible: compatibleVariants(product, index >= 0 ? index : null) };
      }).filter(item => item.index >= 0 || item.compatible.length);
      if (!items.length) {
        const emptyBox = el('div', '', { class: 'pa-empty' });
        emptyBox.append(el('span', '', { class: 'pa-empty__mark', 'aria-hidden': 'true' }), el('p', t.empty));
        body.append(emptyBox);
        return;
      }
      const grid = el('ul', '', { class: 'pa-grid' });
      items.forEach(({ product, index, compatible }) => {
        loadImage(product);
        const selected = index >= 0;
        const card = el('li', '', { class: `pa-card${selected ? ' is-selected' : ''}`, 'data-product-card': String(product.id) });
        card.append(thumb(product, 'pa-card__media'));
        const info = el('div', '', { class: 'pa-card__info' });
        const minPrice = Math.min(...(selected ? [variantFor(lines[index])?.price ?? Infinity] : compatible.map(v => v.price)));
        info.append(el('strong', product.title), el('small', Number.isFinite(minPrice) ? `${!selected && compatible.length > 1 ? `${t.from} ` : ''}${money(minPrice)}` : '—'));
        card.append(info);
        const pickBtn = button(selected ? t.picked : t.pick, () => {
          if (selected) { lines.splice(index, 1); render(); return; }
          const first = compatibleVariants(product, null)[0];
          if (!first) return;
          lines.push({ product, variant: String(first.id), quantity: 1 });
          render();
        }, { class: `pa-pick${selected ? ' is-selected' : ''}`, 'aria-pressed': String(selected), 'aria-label': `${selected ? t.remove : t.pick}: ${product.title}`, 'data-focus-key': `pick-${product.id}` });
        card.append(pickBtn);
        if (selected) {
          const line = lines[index];
          if (product.variants.length > 1) card.append(variantField(line, index));
          card.append(stepper(line));
        }
        grid.append(card);
      });
      body.append(grid);
    };

    const render = (focusStep = false) => {
      const focusKey = dialog.contains(document.activeElement) ? document.activeElement.dataset?.focusKey : null;
      body.replaceChildren();
      footer.replaceChildren();
      error.textContent = '';
      renderProgress();
      dialog.dataset.step = ['quantity', 'interval', 'summary', 'select'][step];
      const heading = head(step === 3 ? t.pickTitle : step === 2 ? t.title : t.steps[step], [t.qtyHint, t.intervalHint, t.summaryHint, t.pickHint][step]);
      if (loading && step !== 3) body.append(el('p', c[0], { class: 'pa-hint', role: 'status' }));
      if (providerError) body.append(el('p', c[1], { class: 'pa-notice pa-notice--error', role: 'status' }));
      if (step === 0) renderQuantity();
      else if (step === 1) renderInterval();
      else if (step === 2) renderSummary();
      else renderPicker();
      if (step === 3) {
        footer.append(el('span'), button(t.done, () => { step = 2; render(true); }, { class: 'pa-primary', 'data-focus-key': 'grid-done' }));
      } else {
        if (step) footer.append(button(t.back, () => { step--; render(true); }, { class: 'pa-back', 'data-focus-key': 'back' }));
        else footer.append(el('span'));
        if (step < 2) footer.append(button(t.next, () => {
          if (!valid()) { error.textContent = t.invalid; return; }
          step++; render(true);
        }, { class: 'pa-primary', 'data-focus-key': 'next' }));
      }
      if (submitting) dialog.querySelectorAll('button,input,select').forEach(control => { control.disabled = true; });
      if (focusStep) { heading.focus({ preventScroll: true }); shell.scrollTop = 0; dialog.scrollTop = 0; }
      else if (focusKey) [...dialog.querySelectorAll('[data-focus-key]')].find(control => control.dataset.focusKey === focusKey)?.focus();
    };
    const refresh = async () => {
      // Opening while initial discovery is pending must not duplicate requests
      // or let an older result replace a newer authority response.
      if (loading) return;
      loading = true; providerError = false; render();
      try {
        if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/')) throw new Error('ENDPOINT');
        const data = await request(endpoint.href);
        if (!Array.isArray(data.variants) || !Array.isArray(data.blockers) || typeof data.ready !== 'boolean' || data.currency !== 'CHF') throw new Error('CONTRACT');
        offer = data;
        const products = new Map([[String(catalog[0].id), catalog[0]]]);
        catalog[0].variants.forEach(variant => { variant.plans = []; });
        for (const variant of data.variants) {
          if (!/^\d+$/.test(variant.id) || !/^\d+$/.test(variant.productId) || !Number.isSafeInteger(variant.unitPriceCents) || !Array.isArray(variant.plans)) throw new Error('CONTRACT');
          let product = products.get(variant.productId);
          if (!product) { product = { id: variant.productId, title: variant.productTitle, handle: variant.handle, variants: [] }; products.set(variant.productId, product); }
          let existing = product.variants.find(v => String(v.id) === variant.id);
          if (!existing) { existing = { id: variant.id }; product.variants.push(existing); }
          Object.assign(existing, { title: variant.title, price: variant.unitPriceCents, available: variant.available, plans: variant.plans });
        }
        catalog = [...products.values()];
        // Refresh retained additions too; removed plans must not remain usable.
        lines.forEach(line => {
          const current = products.get(String(line.product.id));
          if (current) line.product = current;
          else line.product.variants.forEach(v => { v.plans = []; });
        });
      } catch { offer = null; providerError = true; }
      finally { loading = false; discoverySettled = true; syncEntry(); render(); }
    };
    const checkoutSelection = async () => {
      if (submitting || uncertain || !valid() || !offer?.ready || !planFor()) return;
      const plan = planFor();
      const selectedLines = lines.map(line => ({ variantId: line.variant, sellingPlanId: plan.id, quantity: line.quantity }));
      const currentFingerprint = JSON.stringify({ weeks, selectedLines });
      if (fingerprint !== currentFingerprint) { fingerprint = currentFingerprint; requestId = crypto.randomUUID(); }
      submitting = true; render();
      let sent = false;
      let pending;
      const accepted = (cart, record) => record.items.every(item => cart.items.filter(line =>
        String(line.variant_id) === item.id && String(line.selling_plan_allocation?.selling_plan?.id) === item.selling_plan
        && line.properties?._seifenabo_request_id === record.requestId
        && line.properties?._seifenabo_offer === 'product_exact_weeks_v1'
        && line.selling_plan_allocation?.price === item.unitPriceCents
      ).reduce((sum, line) => sum + line.quantity, 0) === item.quantity);
      const done = () => { sessionStorage.removeItem(pendingKey); window.location.assign(`${cartRoot}checkout`); };
      try {
        const prior = sessionStorage.getItem(pendingKey);
        if (prior) {
          pending = JSON.parse(prior);
          if (!Array.isArray(pending.items) || !pending.items.length || pending.fingerprint !== currentFingerprint) throw new Error('UNCERTAIN');
          const cart = await request(`${cartRoot}cart.js`);
          if (accepted(cart, pending)) { done(); return; }
          throw new Error('UNCERTAIN'); // Never blindly repeat an ambiguous add.
        }
        const result = await request(endpoint.href, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestId, intervalWeeks: weeks, lines: selectedLines }),
        });
        if (result.requestId !== requestId || result.intervalWeeks !== weeks || result.currency !== 'CHF'
          || result.items?.length !== selectedLines.length
          || !selectedLines.every(line => result.items.filter(item => item.id === line.variantId
            && item.selling_plan === line.sellingPlanId && item.quantity === line.quantity
            && Number.isSafeInteger(item.unitPriceCents) && item.unitPriceCents >= 0
            && item.properties?._seifenabo_request_id === requestId && item.properties?._seifenabo_offer === 'product_exact_weeks_v1').length === 1)
          || result.totalCents !== result.items.reduce((sum, item) => sum + item.unitPriceCents * item.quantity, 0)) throw new Error('CONTRACT');
        const priceChanged = result.items.some(item => variantFor(lines.find(line => line.variant === item.id)).price !== item.unitPriceCents);
        result.items.forEach(item => { const line = lines.find(line => line.variant === item.id); variantFor(line).price = item.unitPriceCents; });
        if (priceChanged) throw new Error('PRICE_CHANGED');
        const cart = await request(`${cartRoot}cart.js`);
        if (cart.items.some(line => line.properties?._seifenabo_request_id === requestId)) throw new Error('UNCERTAIN');
        pending = { requestId, fingerprint: currentFingerprint, items: result.items };
        sessionStorage.setItem(pendingKey, JSON.stringify(pending));
        if (sessionStorage.getItem(pendingKey) !== JSON.stringify(pending)) throw new Error('STORAGE');
        sent = true;
        await request(`${cartRoot}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: result.items.map(item => ({ id: item.id, selling_plan: item.selling_plan, quantity: item.quantity, properties: item.properties })) }),
        });
        if (!accepted(await request(`${cartRoot}cart.js`), pending)) throw new Error('UNCERTAIN');
        done();
      } catch (failure) {
        if (sent && pending) {
          try { if (accepted(await request(`${cartRoot}cart.js`), pending)) { done(); return; } } catch { /* Keep the retry marker. */ }
        }
        uncertain = sent || failure.message === 'UNCERTAIN';
        submitting = false;
        render();
        error.textContent = uncertain ? c[4] : failure.message === 'PRICE_CHANGED' || /^HTTP_(400|409|422)$/.test(failure.message) ? c[3] : c[1];
      } finally { submitting = false; }
    };
    open.addEventListener('click', () => {
      // Preserve an in-wizard variant on reopening, unless the customer has
      // actually changed the underlying PDP selection since the previous open.
      const pdpVariant = root.querySelector('[data-variant-id]').value;
      if (pdpVariant !== lastPdpVariant) lines[0].variant = pdpVariant;
      lastPdpVariant = pdpVariant;
      render();
      dialog.showModal();
      closeButton.focus();
      refresh();
    });
    dialog.addEventListener('close', () => open.focus());
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button,input,select,a[href],[tabindex]')]
        .filter(control => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (!first) { event.preventDefault(); dialog.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    dialog.addEventListener('cancel', event => { if (submitting) event.preventDefault(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) {
      if (submitting) return;
      const rect = shell.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    } });
    if (discoverEntry) {
      // Variant controls update the hidden PDP identity synchronously; bubble
      // afterwards to reveal only the currently available approved selection.
      root.addEventListener('click', syncEntry);
      root.addEventListener('change', syncEntry);
      syncEntry();
      refresh();
    }
  });
})();
